import type { Credential, CredentialFormData } from "@/lib/queries/credentials";
import { api } from "@/lib/http";

function list() {
  return api.raw.get("api/v1/credentials/").json<Array<Credential>>();
}

function create(data: CredentialFormData) {
  return api.raw.post("api/v1/credentials/", { json: data }).json<Credential>();
}

function update(id: number, data: CredentialFormData) {
  return api.raw
    .patch(`api/v1/credentials/${id}`, { json: data })
    .json<Credential>();
}

function remove(id: number) {
  return api.raw.delete(`api/v1/credentials/${id}`);
}

export default {
  list,
  create,
  update,
  remove,
};
